import React, { useState } from 'react';
import { MapPin, ShieldCheck, Clock, CheckCircle2, FileJson, Lock } from 'lucide-react';

export const EVVGPSModule: React.FC = () => {
  const [gpsLocation, setGpsLocation] = useState<{ lat: number; lng: number } | null>({ lat: 18.5204, lng: 73.8567 });
  const [status, setStatus] = useState<'IDLE' | 'VERIFIED'>('VERIFIED');

  const handleAcquireGPS = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setGpsLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude });
          setStatus('VERIFIED');
        },
        () => {
          setStatus('VERIFIED'); // Fallback demo verification
        }
      );
    }
  };

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-500/20 text-emerald-300 text-xs font-bold rounded-full border border-emerald-500/30">
            <MapPin className="w-3.5 h-3.5" /> Module 28: Electronic Visit Verification (EVV) & Caregiver GPS
          </div>
          <h2 className="text-2xl font-black mt-2">Medicaid & NDIS EVV Session Clock-In / Clock-Out</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black text-emerald-400 font-mono">VERIFIED</div>
          <div className="text-xs text-slate-400">Cryptographic GPS Session Status</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <MapPin className="w-4 h-4 text-emerald-400" /> HTML5 Geolocation Telemetry
          </h3>

          <div className="p-4 bg-slate-900 rounded-xl border border-slate-800 space-y-2 text-xs font-mono text-slate-300">
            <div>Latitude: <span className="text-emerald-400 font-bold">{gpsLocation?.lat.toFixed(4)}° N</span></div>
            <div>Longitude: <span className="text-emerald-400 font-bold">{gpsLocation?.lng.toFixed(4)}° E</span></div>
            <div>Timestamp: <span className="text-blue-400">{new Date().toLocaleTimeString()}</span></div>
            <div>Provider ID: <span className="text-amber-400">#SLP-2026-904</span></div>
          </div>

          <button onClick={handleAcquireGPS} className="w-full py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl text-xs flex items-center justify-center gap-2 shadow">
            <ShieldCheck className="w-4 h-4" /> Re-Verify Browser GPS Telemetry
          </button>
        </div>

        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <FileJson className="w-4 h-4 text-blue-400" /> EVV Compliance JSON Payload
          </h3>
          <pre className="p-3 bg-slate-900 rounded-xl border border-slate-800 text-[10px] font-mono text-slate-300 overflow-x-auto">
{`{
  "evv_id": "EVV-2026-0802-991",
  "client_id": "STU-884",
  "location": { "lat": ${gpsLocation?.lat}, "lng": ${gpsLocation?.lng} },
  "status": "CHECKED_IN",
  "sha256": "e3b0c44298fc1c149afbf4c8996fb924"
}`}
          </pre>
        </div>
      </div>
    </div>
  );
};
